import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { history } from '@history';
import { WithTheme } from '@hocs';
import { AppRouter } from '@components';
import '@localization';
import AppComponent from './app.component';
import store from './store';
import { jsx as _jsx } from "react/jsx-runtime";
var container = document.getElementById('root');
var root = createRoot(container);
root.render( /*#__PURE__*/_jsx(Provider, {
  store: store,
  children: /*#__PURE__*/_jsx(WithTheme, {
    children: /*#__PURE__*/_jsx(AppRouter, {
      history: history,
      children: /*#__PURE__*/_jsx(AppComponent, {})
    })
  })
}));